import React from 'react';
import T from 'prop-types';

import AppInfo from './AppInfo';
import Button from '../../../../components/Buttons/Button';
import VelocityChange from '../../../../components/VelocityChange';

import { numberToPercentage } from '../../../../utils/formatter';

const FavoriteCompetitors = ({ competitors, isMobileView }) => (
  <div className="favorite-competitors shared-competitors-comparisons">
    {competitors.header_text && <h2 className="h2">{competitors.header_text}</h2>}
    {competitors.sub_header_text &&
      <div
        className="paragraph"
        dangerouslySetInnerHTML={{
          __html: competitors.sub_header_text,
        }}
      />}
    <div className="apps-list">
      {competitors.apps.map((app, index) => (
        <a key={index} className="app-item" href={app.app_link_url}>
          <div className="main-app-info">
            <AppInfo
              app={app}
              size={isMobileView ? 40 : 48}
              enableTooltip={!isMobileView}
            />
            <div className="app-change">
              <span>{numberToPercentage(app.change)}</span>
              <VelocityChange change={app.change} />
            </div>
          </div>
          {!isMobileView && (
            <Button
              className="app-link"
              variant="light"
              shape="square"
            >
              <i className="hicon-angle-up-alt" />
            </Button>
          )}
        </a>
      ))}
    </div>
  </div>
);

FavoriteCompetitors.propTypes = {
  competitors: T.shape({
    header_text: T.string,
    sub_header_text: T.string,
    apps: T.array,
  }).isRequired,
  isMobileView: T.bool.isRequired,
};

export default FavoriteCompetitors;
